import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Checkbox, Tag} from "@blueprintjs/core";

import {SearchableDataGrid} from "../../../../components/tables/data-grid";
import * as AuthAPI from "../../../../services/auth-api";
import {DataPageContext} from "../../context";
import {timeAgo} from "../../../../utils/time";
import {CreateCapability} from "./create-capability";


const capabilityColumns = [
    {
        key: 'id',
        name: 'Id',
        width: 50,
        sortable: true,
        filterable: true,
    },
    {
        key: 'resource',
        name: 'Resource',
        width: 175,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params) => <Tag intent="primary">{params.row.resource}</Tag>
    },
    {
        key: 'canCreate',
        name: 'Create',
        width: 65,
        resizable: true,
        formatter: (params) => <Checkbox checked={!!params.row.canCreate} readOnly />
    },
    {
        key: 'canRead',
        name: 'Read',
        width: 65,
        resizable: true,
        formatter: (params) => <Checkbox checked={!!params.row.canRead} readOnly />
    },
    {
        key: 'canUpdate',
        name: 'Update',
        width: 65,
        resizable: true,
        formatter: (params) => <Checkbox checked={!!params.row.canUpdate} readOnly />
    },
    {
        key: 'canDelete',
        name: 'Delete',
        width: 65,
        resizable: true,
        formatter: (params) => <Checkbox checked={!!params.row.canDelete} readOnly />
    },
    {
        key: 'visibility',
        name: 'Visibility',
        width: 120,
        resizable: true,
        sortable: true,
        filterable: true,
    },
    {
        key: 'name',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true,
    },
    {
        key: 'auraAdminOnly',
        name: 'Internal only',
        width: 130,
        resizable: true,
        formatter: (params) => <Checkbox checked={!!params.row.auraAdminOnly} readOnly />
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params) =>
            <span title={params.row.createdAt}>{timeAgo(params.row.createdAt)}</span>,
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params) =>
            <span title={params.row.updatedAt}>{timeAgo(params.row.updatedAt)}</span>,
    },
];


const ManyCapabilities = () => {
    const {setLoading, setNav, setCount} = useContext(DataPageContext);
    const [data, setData] = useState(null);
    const [creating, setCreating] = useState(false);
    const [fetchTrigger, setFetchTrigger] = useState(0);

    const toggleCreating = useCallback(() => setCreating(prev => !prev), []);

    useEffect(() => {
        setNav({right: [
            {name: "New Capability", onClick: toggleCreating, icon: "plus"}
        ]});
    }, []);

    useEffect(() => {
        setLoading({status: true, location: "Loading capabilities..."});
        AuthAPI.capabilities.list(true).then(({data: capabilities}) => {
            console.log("Loaded " + capabilities.length + " capabilities");
            setData(capabilities);
            setLoading({status: false, location: "Capabilities"});
        }).catch(error => {
            console.error(error);
            setLoading({status: false, location: "Failed to load capabilities..."});
            setData([]);
        });
    }, [fetchTrigger]);

    return <>
        <SearchableDataGrid
            columns={capabilityColumns}
            data={data ?? []}
            defaultSort='id'
            onCount={(filtered, total) => setCount({filtered, total})}
        />
        <CreateCapability
            isOpen={creating}
            onClose={() => {
                setCreating(false);
                setFetchTrigger(prev => prev + 1);
            }}
        />
    </>;
}

export {ManyCapabilities};